module.exports = __webpack_public_path__ + "static/media/frames-16.a2303eca.jpg";